<!-- Start Header Section -->
<header class="fn__header-pane fn__header-pane--advisor js-sticky-header">
  <div class="fn__global-header fn__global-header--advisor js-global-header">
    <nav class="fn__global-header__container">
      <div class="fn__global-header__logo">
        <a
          href="https://www.trustage.com/business-solutions/annuities"
          aria-label="TruStage Annuities homepage"
          rel="noopener noreferrer"
          title="TruStage Annuities homepage"
          target="_blank"
          ><img src="https://static.trustage.com/brand/assets/images/trustage-logo.svg" alt="TruStage Logo"
        /></a>
      </div>
      <div class="fn__global-header__menu">
        <section class="fn__primary-nav js-primary-nav">
          <div class="fn__global-header__search">
            <div class="small-devices fn__header-search js-header-search">
              <button
                type="button"
                (click)="openSearchBar()"
                aria-label="toggle keyword search input"
                [ngClass]="{ 'is-open': isSearchBarOpened }"
                class="fn__header-search__button js-header-search-button"
                aria-controls="fn__header-search__input-wrapper"
                aria-expanded="false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                >
                  <g>
                    <g transform="translate(-158 -656)">
                      <path
                        d="M170.15 666.7l4.85 4.85-1.45 1.45-4.86-4.85v-.77l-.26-.27a6.32 6.32 0 1 1 .68-.68l.27.26zm-5.83 0a4.37 4.37 0 1 0 .01-8.74 4.37 4.37 0 0 0-.01 8.73z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </button>
              <div class="fn__header-search__content js-header-search-content" id="fn__header-search__input-wrapper">
                <div class="fn__header-search__form">
                  <div class="fn__header-search__container">
                    <label class="fn__header-search__label">
                      <input
                        type="text"
                        name="q"
                        id="q"
                        [(ngModel)]="inputText"
                        #inputSearchField_small
                        (keydown.enter)="onSearchSubmit(inputText)"
                        [ngClass]="{ 'is-dirty': inputText.trim().length > 0 }"
                        class="fn__header-search__input js-header-search-input"
                      />
                      <span class="fn__header-search__placeholder">Search by keyword...</span>
                    </label>
                    <button
                      type="submit"
                      (click)="onSearchSubmit(inputText)"
                      class="fn__header-search__submit fn__button fn__button--tertiary fn__button--small"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            class="fn__hamburger-button js-hamburger-button"
            [ngClass]="{ 'is-open': isHamburgerMenuIconclicked }"
            type="button"
            aria-label="open or close the Main Navigation"
            (click)="toggleHamburgerMenuIcon()"
          >
            <span class="fn__hamburger-button__icon"></span>
          </button>

          <div class="fn__primary-nav__wrapper" style="box-shadow: none">
            <div class="fn__primary-nav__container">
              <div class="fn__primary-nav__menu-item">
                <a
                  class="fn__primary-nav__top-link is-active"
                  [ngClass]="{ 'is-active': is_active === 'home' }"
                  [routerLink]="['/advisor']"
                  (click)="setActiveClass('home'); resetArrowImage(); navigateToUrlBeforeLogin('/advisor')"
                >
                  <span>Home</span>
                </a>
              </div>
              <div
                class="fn__primary-nav__menu-item js-primary-nav-menu js-primary-nav-menu-item"
                (click)="toggleSubMenu()"
              >
                <button
                  type="button"
                  class="fn__primary-nav__top-link fn__primary-nav__top-link--button js-primary-nav-top-link"
                  id="hl__top-link-1"
                  aria-live="assertive"
                  aria-label="Tools toggle submenu"
                  [attr.aria-expanded]="!isMenuCollapsed"
                  [ngClass]="{ 'is-active': is_active === 'tools' }"
                >
                  <span>Tools</span>
                  <img id="arrowIcon_T" src="../../../../assets/images/Caret.svg" alt="" />
                </button>
                <div
                  *ngIf="isMenuCollapsed"
                  class="fn__primary-nav__sub-menu js-primary-nav-sub-menu"
                  (click)="onSubMenuBlockClick($event)"
                >
                  <div class="fn__primary-nav__sub-container">
                    <ul
                      class="fn__primary-nav__items js-primary-nav-sub-menu-items"
                      role="menu"
                      aria-labelledby="hl__top-link-2"
                    >
                      <li *ngFor="let column of [0, 1, 2]">
                        <div class="column-1">
                          <ul class="fn__primary-nav__itemss js-primary-nav-sub-menu-items">
                            <li
                              class="fn__primary-nav__item js-primary-nav-sub-menu-item"
                              role="menuitem"
                              *ngFor="let links of getLinksForColumn(column)"
                            >
                              <a
                                *ngIf="links.url.includes(curentDomin); else externalLink"
                                (click)="navigateToUrl(links.url.replace(curentDomin, ''), links.target)"
                                class="fn__primary-nav__sub-link"
                                rel="noopener noreferrer"
                                (click)="closeSubMenuItemClick(links.target)"
                                tabindex="-1"
                                >{{ links.text }}</a
                              >
                              <ng-template #externalLink>
                                <a
                                  [href]="links.url"
                                  class="fn__primary-nav__sub-link"
                                  rel="noopener noreferrer"
                                  (click)="closeSubMenuItemClick(links.target)"
                                  [target]="links.target"
                                  tabindex="-1"
                                >
                                  {{ links.text }}
                                </a>
                              </ng-template>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class="fn__primary-nav__menu-item js-primary-nav-menu js-primary-nav-menu-item"
                (click)="toggleSubMenuForResources()"
              >
                <button
                  type="button"
                  class="fn__primary-nav__top-link fn__primary-nav__top-link--button js-primary-nav-top-link"
                  id="hl__top-link-2"
                  aria-live="polite"
                  aria-label="Resources toggle submenu"
                  [attr.aria-expanded]="!isMenuCollapsedForResuorces"
                  [ngClass]="{ 'is-active': is_active === 'resources' }"
                >
                  <span>Resources</span>
                  <img id="arrowIcon_R" src="../../../../assets/images/Caret.svg" alt="" />
                </button>
                <div
                  *ngIf="isMenuCollapsedForResuorces"
                  class="fn__primary-nav__sub-menu js-primary-nav-sub-menu"
                  (click)="onSubMenuBlockClick($event)"
                >
                  <div class="fn__primary-nav__sub-container">
                    <ul
                      class="fn__primary-nav__items js-primary-nav-sub-menu-items"
                      role="menu"
                      aria-labelledby="hl__top-link-2"
                    >
                      <li
                        class="fn__primary-nav__item js-primary-nav-sub-menu-item"
                        role="menuitem"
                        *ngFor="let links of linksResources"
                      >
                        <a
                          *ngIf="links.url.includes(curentDomin); else externalLink"
                          (click)="navigateToUrl(links.url.replace(curentDomin, ''), links.target)"
                          class="fn__primary-nav__sub-link"
                          (click)="closeSubMenuItemClick(links.target)"
                          rel="noopener noreferrer"
                          tabindex="-1"
                          >{{ links.text }}</a
                        >
                        <ng-template #externalLink>
                          <a
                            [href]="links.url"
                            class="fn__primary-nav__sub-link"
                            (click)="closeSubMenuItemClick(links.target)"
                            [target]="links.target === '_default' ? null : links.target"
                            tabindex="-1"
                          >
                            {{ links.text }}
                          </a>
                        </ng-template>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="fn__primary-nav__menu-item fn__primary-nav__menu-item--utility">
                <a
                  class="fn__primary-nav__top-link"
                  (click)="navigateToContact()"
                  [ngClass]="{ 'is-active': is_active === 'contact' }"
                  (click)="setActiveClass('contact')"
                  tabindex="0"
                  role="button"
                  href="javascript:void(0)"
                >
                  <span>Contact</span>
                </a>
              </div>
              <div class="fn__primary-nav__menu-item fn__primary-nav__menu-item--utility">
                <a
                  class="fn__primary-nav__top-link"
                  [routerLink]="['/BOB-Landing']"
                  [ngClass]="{ 'is-active': is_active === 'bob' }"
                  (click)="setActiveClass('bob'); resetArrowImage(); navigateToUrlBeforeLogin('/BOB-Landing')"
                >
                  <span>Book of Business</span>
                </a>
              </div>
              <div class="fn__primary-nav__search">
                <div class="fn__header-search js-header-search">
                  <button
                    (click)="openSearchBar()"
                    [ngClass]="{ 'is-open': isSearchBarOpened }"
                    type="button"
                    aria-label="toggle keyword search input"
                    class="fn__header-search__button js-header-search-button hamburger-open"
                    aria-controls="fn__header-search__input-wrapper"
                  >
                    <img id="arrowIcon_T" src="../../../../assets/images/Search.svg" alt="" />
                  </button>
                  <div
                    class="fn__header-search__content js-header-search-content"
                    id="fn__header-search__input-wrapper"
                  >
                    <div class="fn__header-search__form">
                      <div class="fn__header-search__container">
                        <label class="fn__header-search__label">
                          <input
                            type="text"
                            name="q"
                            id="q"
                            #inputSearchField
                            (keydown.enter)="onSearchSubmit(inputText)"
                            [(ngModel)]="inputText"
                            [ngClass]="{ 'is-dirty': inputText.trim().length > 0 }"
                            class="fn__header-search__input js-header-search-input"
                          />
                          <span class="fn__header-search__placeholder">Search by keyword...</span>
                        </label>
                        <button
                          type="submit"
                          (click)="onSearchSubmit(inputText)"
                          class="fn__header-search__submit fn__button fn__button--tertiary fn__button--small"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="fn__primary-nav__menu-item js-primary-nav-menu js-primary-nav-menu-item"
                (click)="toggleSubMenuForProfile()"
              >
                <button
                  type="button"
                  class="fn__primary-nav__top-link fn__primary-nav__top-link--button js-primary-nav-top-link"
                  id="hl__top-link-3"
                  aria-live="assertive"
                  aria-label="Profile toggle submenu"
                  [attr.aria-expanded]="!isMenuCollapsedForProfile"
                  [ngClass]="{ 'is-active': is_active === 'profile' }"
                >
                  <span>My Profile</span>
                  <img id="arrowIcon_T" src="../../../../assets/images/Caret.svg" alt="" />
                </button>
                <div
                  *ngIf="isMenuCollapsedForProfile"
                  class="fn__primary-nav__sub-menu js-primary-nav-sub-menu profile-submenu"
                  (click)="onSubMenuBlockClick($event)"
                >
                  <div class="fn__primary-nav__sub-container">
                    <ul
                      class="fn__primary-nav__items js-primary-nav-sub-menu-items"
                      role="menu"
                      aria-labelledby="hl__top-link-3"
                    >
                      <div class="column-1">
                        <ul class="fn__primary-nav__itemss js-primary-nav-sub-menu-items">
                          <li
                            class="fn__primary-nav__item js-primary-nav-sub-menu-item"
                            role="menuitem"
                            *ngIf="!loginCheck && advisorList && advisorList.length > 0"
                          >
                            <span class="fn__primary-nav__logged-in" rel="noopener noreferrer" tabindex="-1"
                              >Logged in as:
                              <br />
                              <span class="fn__primary-nav__logged-in-username"
                                >{{
                                  this.advisorList[selectedAdvisorIndex].firstName +
                                    ' ' +
                                    this.advisorList[selectedAdvisorIndex].lastName
                                }}
                              </span>
                            </span>
                          </li>
                          <li
                            *ngIf="windowIsLarge && !loginCheck && advisorList && advisorList.length > 0"
                            class="fn__primary-nav__item js-primary-nav-sub-menu-item"
                            role="menuitem"
                            style="position: relative"
                          >
                            <a
                              class="fn__primary-nav__Switchaccounts"
                              href="javascript:void(0)"
                              tabindex="-1"
                              (click)="toggleAdvisorMenu(); $event.stopPropagation()"
                              (keydown.enter)="toggleAdvisorMenu(); $event.stopPropagation()"
                            >
                              Switch Account
                              <img
                                class="fn__primary-nav__Rightnav"
                                src="../../../../assets/images/RightArrow.png"
                                alt="Show advisor list"
                                style="cursor: pointer"
                                tabindex="0"
                              />
                            </a>
                            <span *ngIf="showAdvisorMenu" class="fn__primary-advisor-nav__sub-menu">
                              <ul class="fn__primary-advisor-nav__sub-menuul">
                                <li
                                  *ngFor="let advisor of advisorList; let i = index"
                                  (click)="selectAdvisor(i); $event.stopPropagation()"
                                  class="fn__primary-advisor-nav__sub-menuli"
                                >
                                  <img
                                    *ngIf="selectedAdvisorIndex === i"
                                    src="../../../../assets/images/icon-check.png"
                                    alt="Selected advisor"
                                  />
                                  <span class="fn__Primary-advisor-name">{{
                                    advisor.firstName + ' ' + advisor.lastName
                                  }}</span>
                                </li>
                              </ul>
                            </span>
                          </li>
                          <li
                            *ngIf="windowIsSmall && !loginCheck && advisorList && advisorList.length > 0"
                            class="fn__primary-nav__item js-primary-nav-sub-menu-item"
                            role="menuitem"
                          >
                            <div class="fn__primary-nav__Switchaccounts" tabindex="0">
                              Switch Account
                              <img
                                class="fn__primary-nav__Rightnav"
                                [src]="
                                  showAdvisorMenu
                                    ? '../../../../assets/images/chevron-up.svg'
                                    : '../../../../assets/images/chevron-down.svg'
                                "
                                alt="Toggle advisor list"
                                style="cursor: pointer"
                                tabindex="0"
                                (click)="toggleAdvisorMenu(); $event.stopPropagation()"
                                (keydown.enter)="toggleAdvisorMenu(); $event.stopPropagation()"
                              />
                            </div>
                            <ul *ngIf="showAdvisorMenu" class="fn__primary-advisor-nav__sub-menu_smallul">
                              <li
                                *ngFor="let advisor of advisorList; let i = index"
                                [class.selected]="selectedAdvisorIndex === i"
                                class="fn__primary-advisor-nav__sub-menuSmallWindowli"
                              >
                                <img
                                  *ngIf="selectedAdvisorIndex === i"
                                  src="../../../../assets/images/icon-check.png"
                                  alt="Selected advisor"
                                />
                                <a
                                  class="fn__Primary-advisor-name"
                                  tabindex="-1"
                                  href="javascript:void(0)"
                                  (click)="selectAdvisor(i); $event.stopPropagation()"
                                >
                                  {{ advisor.firstName + ' ' + advisor.lastName }}
                                </a>
                              </li>
                            </ul>
                          </li>
                          <ng-container *ngIf="accessDelegation">
                            <li
                              *ngIf="accessDelegation && !loginCheck"
                              class="fn__primary-nav__item js-primary-nav-sub-menu-item p-0"
                              role="menuitem"
                            >
                              <span class="fn__primary-nav__lineSpacing">
                                <div class="fn__primary-nav__line"></div>
                              </span>
                            </li>
                            <li class="fn__primary-nav__item js-primary-nav-sub-menu-item" role="menuitem">
                              <a
                                class="fn__primary-nav__sub-link"
                                rel="noopener noreferrer"
                                tabindex="-1"
                                [routerLink]="['/delegate-user']"
                                (click)="
                                  setActiveClass('profile');
                                  resetArrowImage();
                                  navigateToUrlBeforeLogin('/advisor/profile')
                                "
                                >Access Settings</a
                              >
                            </li>
                          </ng-container>
                          <li class="fn__primary-nav__item js-primary-nav-sub-menu-item" role="menuitem">
                            <a
                              class="fn__primary-nav__sub-link"
                              rel="noopener noreferrer"
                              tabindex="-1"
                              [routerLink]="['/advisor/profile']"
                              (click)="
                                setActiveClass('profile');
                                resetArrowImage();
                                navigateToUrlBeforeLogin('/advisor/profile')
                              "
                              >Profile Settings</a
                            >
                          </li>
                        </ul>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="fn__primary-nav__menu-item fn__primary-nav__menu-item--utility">
                <a
                  class="fn__primary-nav__top-link"
                  href="javascript:void(0)"
                  (click)="_authorize.startLogout(); setActiveClass($event)"
                >
                  <span (click)="_emulationService.stopEmulationonLogout(); _switchAdvisor.stopSwtichAdvisorLogout()"
                    >Log Out</span
                  >
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </nav>
  </div>
</header>
<!-- End Header Section -->

<!-- Switch Advisor Alert-->
<div
  class="cm__emulating-message"
  *ngIf="_switchAdvisor.showDisplayer"
  #switchAdvisorDisplayer
  id="switchAdvisorDisplayer"
  role="alert"
>
  <div class="cm__emulating-message__wrap">
    <div class="cm__emulating-message__text" *ngIf="advisorList && advisorList.length > 0">
      <span id="switchedadvisor-logged-in-label">You are logged in as:</span>
      <b aria-labelledby="switchedadvisor-logged-in-label" tabindex="0">
        {{ this.advisorList[selectedAdvisorIndex].firstName + ' ' + this.advisorList[selectedAdvisorIndex].lastName }}
      </b>
    </div>
    <div class="cm__emulating-message__action" (click)="_switchAdvisor.showDisplayer = false">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M18.968 6.406L13.39 11.984L18.968 17.562L17.562 18.968L11.984 13.39L6.406 18.968L5 17.562L10.578 11.984L5 6.406L6.406 5L11.984 10.578L17.562 5L18.968 6.406Z"
          fill="#424242"
        />
      </svg>
    </div>
  </div>
</div>
